import {lazy} from './lazy.js';
import {doc} from './documentation.js';

doc(
    "alt",
    {
        "arg1": "",
        "arg2": "",
        "argN": "",
    },
    "Alternates between the arguments with every trigger received by this function"
);
export const alt = (...altArgs) => {
    let counter = 0;
    return (... args) => {
        let index = counter++ % altArgs.length
        return lazy(altArgs[index], ...args);
    };
};

doc(
    "every",
    {
        "n": "",
        "fn": "",
        "elseFn": "",
    },
    "Every n-many triggers do something, otherwise do something else. The else is optional."
);
export const every = (n, fn, elseFn) => {
    let counter = 0;
    return (... args) => {
        let _n = lazy(n, ...args);
        let modded = ++counter % _n;
        if (modded === 0) {
            return fn(...args);
        }
        // otherwise return the coordinates unchanged (i.e. the first argument)
        if (elseFn) {
            return elseFn(...args);
        }
        return args[0];
    };
};


doc(
    "altn",
    {
        "n": "How many triggers it takes to increment the output conditional",
        "arg1": "Output conditional",
        "arg2": "Output conditional",
        "argN": "Output conditional (will loop back to arg1 after this this)",
    },
    "Alternates between the arguments every n-many triggers received by this function"
);
export const altn = (n, ... outputs) => {
    let counter = 0;
    let outputNumber = 0;
    return (...args) => {
        let _n = lazy(n, ...args);
        if (++counter % _n === 0) {
            outputNumber++;
        }
        let output = outputs[outputNumber % outputs.length];
        return lazy(output, ...args);
    };

};
